<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div>
        <span style="font-size: 13px; color:#97a8be">首页 / 抽奖管理 / 奖品列表</span>
      </div>
    </div>
    <div style="overflow:hidden; padding:15px 15px; padding-top: 0; line-height: 43px ">
      <span class="leftTd">奖品名称</span>
      <input class="boxText" v-model="awardName" style="width: 200px; margin-left: 10px;">
      <span class="leftTd" style="margin-left: 15px;">奖品类型</span>
      <select class="boxText" v-model="type" style="width: 200px; margin-left: 10px;">
        <option value="">全部</option>
        <option value="0">实物</option>
        <option value="1">现金红包</option>
      </select>
      <span class="leftTd" style="margin-left: 15px;">状态</span>
      <select class="boxText" v-model="state" style="width: 200px; margin-left: 10px;">
        <option value="">全部</option>
        <option value="0">启用</option>
        <option value="1">禁用</option>
      </select>
      <input @click="selectAdminList" type="button" style="cursor: pointer; padding: 7px 25px; border-radius: 3px; margin-left: 10px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="搜索" />
    </div>
    <div style="overflow:hidden; padding:0 15px;">

      <div @click="addAdmin" class="addBtn">+ 添加奖品</div>
    </div>
    <div style="padding: 10px 15px">
      <div style="overflow-x: scroll">
        <table width="100%">
          <tr>
            <th class="th">
              操作
            </th>
            <th class="th">
              奖品名称
            </th>
            <th class="th">
              奖品图片
            </th>
            <th class="th">
              中奖概率
            </th>
            <th class="th">
              奖品类型
            </th>
            <th class="th">
              现金红包金额
            </th>
            <th class="th">
              状态
            </th>
          </tr>
          <tr :key="index" v-for="(value,index) in adminList">
            <td class="td">
              <div style="overflow: hidden;min-width: 100px;">
                <div @click="updateAdmin(value)" style="cursor: pointer; float: left; color: #1890ff">
                  编辑
                </div>
                <div @click="deleteProject(value.awardId)" style="cursor: pointer; margin-left: 10px; float: left; color: #1890ff">
                  删除
                </div>
              </div>
            </td>
            <td class="td">
              {{ value.awardName }}
            </td>
            <td class="td">
              <img v-if="value.awardIcon!=''" :src="imgUrl+value.awardIcon" style="width: 50px; height: 50px" />
              <span v-if="value.awardIcon==''">未上传</span>
            </td>
            <td class="td">
              {{ value.awardRate }}%
            </td>
            <td class="td">
              {{value.awardType==0?'实物':'现金红包'}}
            </td>
            <td class="td">
              {{value.awardNote}}
            </td>
            <td class="td">
              {{value.awardState==0?'启用':'禁用'}}
            </td>

          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, FILE_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost} from "@/main";

export default {
  name: "AwardList",
  data(){
    return{
      code:"",
      awardName:"",
      type:"",
      state:"",
      recommend:"",
      adminList:[],
      page:1,
      num:10,
      count:0,
      countPage:0,
      imgUrl:"",
      levelList:[],
      teamLevelList:[]
    }
  },
  mounted(){
    this.imgUrl=FILE_URL
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    this.selectAdminList()
  },
  methods: {
    deleteProject(id){
      let that=this
      if(confirm("确认删除此奖品？")){
        axiosPost(DO_NET_URL+"choujiang/DeleteAward?id="+id,"",function (res){
          console.log(res)
          if(res.code==200){
            toask("删除成功！",6)
            that.selectAdminList()
          }else{
            toask(res.data,6)
          }
        })
      }
    },
    updateSchedule(id,e){
      if(e==""){
        toask("进度不能为空！",6)
        return
      }
      axiosPost(DO_NET_URL+"project/UpdateScheduleByFund?projectId="+id+"&projectSchedule="+e,function (res){

      })
      console.log(id)
      console.log(e)
    },
    addValue(code){
      localStorage.setItem("userCode",code)
      this.$emit("send","addRate")
    },
    breakProject(code){
      localStorage.setItem("userCode",code)
      this.$emit("send","breakProject")
    },
    childUser(code){
      localStorage.setItem("userCode",code)
      this.$emit("send","childUser")
    },
    updateAdmin(obj){
      localStorage.setItem("UPDATEOBJ",JSON.stringify(obj))
      this.$emit("send",'updateAward')
    },

    addAdmin(){
      this.$emit("send",'addAward')
    },
    currPage(num){
      if(num==1){
        this.page=1
      }else if(num==5){
        this.page=this.countPage
      }else if(num==2){
        if(this.page>1){
          this.page-=1
        }
      }else{
        if(this.page<this.countPage){
          this.page+=1
        }
      }
      this.selectAdminList()
    },
    async selectAdminList(){
      let that=this
      loading("加载中")
      axiosGet(DO_NET_URL+"choujiang/GetAwardList?awardName="+this.awardName+"&type="+this.type+"&state="+this.state,function (res){
        console.log(res.data)
        closeLoading()
        // that.imgUrl=res.data.imgUrl
        that.adminList=res.data
        // that.count=res.data.num
        // let page=parseInt(res.data.num/that.num)
        // if(res.data.num%that.num>0){
        //   page+=1
        // }
        // that.countPage=page
        // localStorage.setItem("imgUrl",res.data.imgUrl)
      })
    },
  }
}
</script>

<style scoped>
.text1{
  border: 1px solid #dcdfe6;
  font-size: 12px;
  border-radius: 2px;
  outline: none;
  padding: 3px 10px;
}
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 35px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700;}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0px 10px; min-width: 100px; width: auto; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>